import Cookies from 'js-cookie';
import { isBrowser } from 'utils/helper';

import { STORAGE } from './storage';
import { ENUM_STORAGE_ACCESS_TOKEN, ENUM_STORAGE_ANIMATOR_TAB, ENUM_STORAGE_LANGUAGE, ENUM_STORAGE_PATH, ENUM_STORAGE_REFRESH_TOKEN } from './storageActions';

const isAnimatorTab = () => sessionStorage.getItem(ENUM_STORAGE_ANIMATOR_TAB) === 'true';

export const getAccess = () => {
	let token = null;
	let scope = null;

	if (isBrowser) {
		const animatorToken = window.accessToken; // stays only in one tab
		const operatorToken = Cookies.get(ENUM_STORAGE_ACCESS_TOKEN); // shared across tabs

		if (animatorToken) {
			token = animatorToken;
			scope = 'animator';
		} else if (operatorToken && !isAnimatorTab()) {
			token = operatorToken;
			scope = 'operator';
		}
	}

	return { token, scope };
};

export const getAccessToken = () => {
	let token = null;
	if(isBrowser) {
		token = window.accessToken || (isAnimatorTab() ? null : Cookies.get(ENUM_STORAGE_ACCESS_TOKEN));
	}
	return token;
};

export const getRefreshToken = () => {
	let token = null;
	if(isBrowser) {
		token = window.refreshToken || (isAnimatorTab() ? null : Cookies.get(ENUM_STORAGE_REFRESH_TOKEN));
	}
	return token;
};


export const getWindowUser = () => {
	let user = STORAGE.USER;
	if(isBrowser && window.user) {
		user = window.user;
	}
	return user;
};

export const getWindowCommons = () => {
	let commons = STORAGE.COMMONS;
	if(isBrowser && window.commons) {
		commons = window.commons;
	}
	return commons;
};

export const getWindowOptions = () => {
	let options = STORAGE.OPTIONS;
	if(isBrowser && window.options) {
		options = window.options;
	}
	return options;
};

export const getStoragePath = () => {
	let path = null;
	if(isBrowser) {
		path = sessionStorage.getItem(ENUM_STORAGE_PATH);
	}
	return path;
};

export const getStorageLanguage = () => {
	let language = null;

	if(isBrowser) {
		language = localStorage.getItem(ENUM_STORAGE_LANGUAGE);
		if(language?.length > 2) {
			language = `${language[0]}${language[1]}`;
		}
	}
	switch(language) {
		case 'pl': return 'pl';
		case 'en': return 'en';
		default: return 'en';
	}
};
